import { createAuthClient } from 'better-auth/react'

// TODO Test if this works with the production URL
export const authClient = createAuthClient({
  baseURL: '',
})
